export const BACKGROUND_COLOR = [
    {label: 'Laranja', value: '#FF954E'},
    {label: 'Ciano', value: '#47DED0'},
    {label: 'Lilas', value: '#9D86ED'},
    {label: 'Rosa', value: '#FF77F1'},
    {label: 'Verde', value: '#B8D335'},
    {label: 'Amarelo escuro', value: '#E59724'},
    {label: 'Azul', value: '#4A7EE4'},
    {label: 'Amarelo', value: '#FFB906'}
];